import { useTheme } from "@/components/theme-provider"
import { Button } from "@/components/ui/button"
import { SunMoon } from "lucide-react"

export const ToggleTheme = () => {
  const { theme, setTheme } = useTheme()

  const handleToggleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark")
  }

  return (
    <Button variant="outline" onClick={handleToggleTheme} className="p-0">
	  <SunMoon size={24} className="!size-6" />
    </Button>
  )
}
